import { render, staticRenderFns } from "./ImgPicker.vue?vue&type=template&id=22e6bda0&"
import script from "./ImgPicker.vue?vue&type=script&lang=ts&"
export * from "./ImgPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports